import type { BasketLineViewModel } from 'autogen/swagger/all';
import CheckBox from 'components/shared/inputs/checkbox';
import { BorderRadiusMedium, Spacing12, Spacing8 } from 'autogen/design-tokens/tokens';
import styled from 'styled-components';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import { AsGift, WithWrappingCard } from 'autogen/translation-keys/trans-website-basket-wrapping';
import { rem } from 'modules/helpers/style';
import useWrappingModalOpener from '../../../hooks/useWrappingModalopener';

const Label = styled.label`
    padding: ${Spacing12};
    display: flex;
    align-items: center;
    gap: ${Spacing8};
    background-color: var(--color-cta-secondary-base);
    border-radius: ${BorderRadiusMedium};
    align-self: start;
    height: ${rem(40)};
    margin: 0;
`;

export default function GiveAsGiftInput({
    model: {
        wrapInfo: { isWrappingCardEnabled, wrappingQuantity, wrappingCardQuantity },
        giftSwapInfo: {
            isGiftingEnabled,
            isGiftable,
            isSwapCertificateEnabled,
            hasSwapCertificate,
            giveAsGiftLineSummaryText
        },

        subscriptionNudge,
        productId
    },
    ...restProps
}: {
    model: BasketLineViewModel;
}) {
    const { t } = useTranslation();
    const isWrappingCardOnly = !isSwapCertificateEnabled && isWrappingCardEnabled;
    const isWrappableOrSwappable = isSwapCertificateEnabled || isWrappingCardOnly;
    const { handleOpenWrappingModal, handleOpenWrappingModalWithConfirmation } = useWrappingModalOpener(
        productId,
        isWrappingCardOnly
    );
    const text = `${isWrappingCardOnly ? t(WithWrappingCard) : t(AsGift)} ${
        hasSwapCertificate && !isWrappingCardOnly ? giveAsGiftLineSummaryText : ''
    }`;

    const isSubscriptionNudged = !!subscriptionNudge?.isToggled;
    const canGift = isGiftingEnabled && isGiftable && !isSubscriptionNudged;

    if (!canGift || !isWrappableOrSwappable) return null;

    return (
        <Label {...restProps}>
            <CheckBox
                checked={hasSwapCertificate}
                onChange={(event) => {
                    if (event.target.checked) {
                        handleOpenWrappingModal();
                    } else {
                        handleOpenWrappingModalWithConfirmation();
                    }
                }}
            />
            <Typography.Body as="span">{text}</Typography.Body>
        </Label>
    );
}
